import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSuitcaseWork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"suitcase-work,workspace"} maskId="square-filled-radius-0-stroke-1-IconSuitcaseWork"><path fillRule="evenodd" clipRule="evenodd" d="M7 2H17V6H22V21H2V6H7V2ZM8 6H16V3H8V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSuitcaseWork;
